#import "./MediaFull.graphql"

fragment ComparisonItemFull on ComparisonItem {
  id
  name
  picture {
    ...MediaFull
  }
}
